module.exports = __webpack_public_path__ + "static/media/sw3.f7975a75.jpg";